import React, { useEffect, useRef, useState } from "react";
import {
  FaArrowLeft,
  FaCheck,
  FaCheckCircle,
  FaSearch,
  FaTrash,
  FaUpload,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import buildLink from "../../../../../urls";
import axios from "axios";
import MessageAlert from "../../../../../components/messageAlert";
import Loader from "../../../../../components/loader";
import { axiosServer } from "../../../../../axiosServer";
import hocStarredPage from "../../../../../components/hocStarredPage";
import Select from "react-select";
import { getDetectedOrderType } from "../../../../../functions/getDetectedOrderType";

const UpdateBinv2 = () => {
  const orderId = useRef(null);
  const binRef = useRef(null);

  const itemref = useRef(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const history = useNavigate();
  const [orderStatus, setOrderStatus] = useState("normal");
  const options = [
    { value: "normal", label: "Normal" },
    { value: "return", label: "Return" },
  ];
  var host = window.location.host;
  const [splitScanProgress, setSplitScanProgress] = useState(null);

  const [show, setShow] = useState(false);

  const updateSplitScanProgress = (data = {}) => {
    const totalPackages = Number(data?.total_packages ?? 0);
    const checkedPackages = Number(data?.checked_packages ?? 0);
    const remainingPackages = Number(
      data?.remaining_packages ?? Math.max(totalPackages - checkedPackages, 0),
    );

    if (
      totalPackages === 0 &&
      checkedPackages === 0 &&
      remainingPackages === 0
    ) {
      return;
    }

    setSplitScanProgress({
      totalPackages,
      checkedPackages,
      remainingPackages,
    });
  };
  const handleTrashClick = () => {
    orderId.current.value = "";
    orderId.current.focus();
  };
  const handleitemTrashClick = () => {
    itemref.current.value = "";
    itemref.current.focus();
  };
  const updateBin = async (e) => {
    e.preventDefault();

    let detectedOrderType = orderStatus;

    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      const {
        success,
        type,
        message: orderTypeMessage,
      } = await getDetectedOrderType(orderId.current.value);

      if (!success) {
        setMessage(orderTypeMessage);
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
        return;
      }

      detectedOrderType = type;
      setOrderStatus(type);
    }

    setLoading(true);

    let order_type;

    if (
      host == "pda.ishtari.com" ||
      host.startsWith("localhost") ||
      host == "pda.ishtari.com.gh"
    ) {
      order_type = detectedOrderType;
    } else {
      order_type = orderStatus;
    }

    const item = itemref.current.value.trim();

    const isSplitOrderId = (item.match(/-/g) || []).length >= 2;

    let url;
    if (isSplitOrderId) {
      url =
        order_type == "normal"
          ? buildLink("updateBinV2")
          : buildLink("updateReturnBinV2");

      setShow(true);
    } else {
      url =
        order_type == "normal"
          ? buildLink("updateBinORder")
          : buildLink("updateReturnBin");

      setShow(false);
    }

    var obj = {};
    if (order_type == "normal") {
      obj.order_id = orderId.current.value;
      obj.bin_id = binRef.current.value;
      obj.item = itemref.current.value;
    } else {
      obj.return_order_id = orderId.current.value;
      obj.bin_id = binRef.current.value;
      obj.item = itemref.current.value;
    }

    try {
      await axiosServer.post(url, obj).then((response) => {
        if (response.data.success) {
          if (isSplitOrderId) {
            updateSplitScanProgress(
              response?.data?.package_scan ?? response?.data?.data,
            );
          }
          setMessage(response.data.message);
          setShowMessageSucc(true);
          setTimeout(() => {
            setShowMessageSucc(false);
          }, 3000);
        } else {
          setMessage(response.data.message);
          setShowMessageErr(true);
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
        }
      });
    } catch (e) {
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
    setLoading(false);
  };

  useEffect(() => {
    orderId.current.focus();
  }, []);

  return (
    <>
      <div className="h-full bg-white">
        {/* header */}
        <div className=" mb-5 sticky top-0 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl my-auto">Update Bin</h2>
            </div>
          </div>
        </div>
        <div className=" container">
          {host !== "pda.ishtari.com" &&
            !host.startsWith("localhost") &&
            host !== "pda.ishtari.com.gh" && (
              <div className="mb-1 ">Order Type</div>
            )}
          <form
            onSubmit={(e) => updateBin(e)}
            className=" flex flex-col gap-5 justify-center"
          >
            {host !== "pda.ishtari.com" &&
              !host.startsWith("localhost") &&
              host !== "pda.ishtari.com.gh" && (
                <Select
                  placeholder="Order Type"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderRadius: "7px",
                      borderColor: state.isFocused ? "grey" : "grey",
                      outline: "red",
                      padding: "8px 5px",
                    }),
                  }}
                  options={options}
                  onChange={(e) => {
                    setOrderStatus(e.value);
                  }}
                />
              )}
            <div className="  flex  justify-center gap-3">
              <div className=" my-auto relative flex-1">
                <div className="mb-1 ">Order ID</div>
                <input
                  required
                  ref={orderId}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="Order Id"
                />
                <FaTrash
                  className="absolute top-[55px] transform -translate-y-1/2 right-2 cursor-pointer opacity-20 "
                  onClick={handleTrashClick}
                />
              </div>
            </div>
            <div className="  flex  justify-center gap-3">
              <div className=" my-auto relative flex-1">
                <div className="mb-1 ">Item</div>
                <input
                  required
                  ref={itemref}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="Item"
                />
                <FaTrash
                  className="absolute top-[55px] transform -translate-y-1/2 right-2 cursor-pointer opacity-20 "
                  onClick={handleitemTrashClick}
                />
              </div>
            </div>

            <div className="  flex  justify-center gap-3 items-end">
              <div className=" my-auto relative flex-1">
                <div className="mb-1 ">BIN</div>
                <input
                  required
                  ref={binRef}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="BIN"
                />
                <FaTrash
                  className="absolute top-[55px] transform -translate-y-1/2 right-2 cursor-pointer opacity-20  "
                  onClick={() => {
                    binRef.current.value = "";
                    binRef.current.focus();
                  }}
                />
              </div>

              <button
                type="submit"
                className=" bg-dbase rounded-md text-white px-5 h-12"
              >
                {" "}
                {loading ? <Loader /> : <FaCheckCircle />}
              </button>
            </div>

            {show && splitScanProgress?.remainingPackages > 0 && (
              <div className="mt-2">
                <div className="p-1">Scanned:</div>
                <div className="space-x-3 flex flex-wrap">
                  <input
                    value={`${splitScanProgress.checkedPackages}/${splitScanProgress.totalPackages}`}
                    readOnly
                    type="text"
                    className="border mb-3 border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2 bg-[#f2f2f2]"
                    placeholder="Scanned"
                  />
                </div>
              </div>
            )}
          </form>
        </div>
        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};
export default hocStarredPage(UpdateBinv2);
